module.exports = require("@pnotify/core");